import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { integerToStringNumberWithIntlGroups } from '../../../helpers/normalizers';
import IwMedia from '../../../iwMedia/index';
import { SHOW_REPAYMENT_SCHEDULE_MODAL } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import DashboardLink from '../../navigation/DashboardLink';
import MainContentPending from '../../pageStructure/mainContentPending';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';
import { TitleSectionWrapper } from '../../pageStructure/titleSectionWrapper/TitleSectionWrapper';
import PairItemContainer from '../../ui/pairItemContainer/PairItemContainer';
import { Prompt } from '../../ui/prompt';
import {
    REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY,
    SHOW_CONFIRM_REPAYMENT_STEP,
    UPDATE_SELECTED_REPAYMENT_AMOUNT
} from '../EarlyRepayment.actions';
import messages from './ChooseRepaymentAmount.messages';
import styles from './ChooseRepaymentAmount.module.css';
import { RepaymentAmountBreakdown } from './repaymentAmountBreakdown/RepaymentAmountBreakdown';
import RepaymentSelectAmount from './repaymentSelectAmount/RepaymentSelectAmount';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { GetEarlyRepaymentSimulationResponse } from '@iwoca/lapi-client/edge';

const mapStateToProps = (state: RootState) => {
    const { intl, earlyRepayment, form } = state;
    return {
        ...intl,
        ...earlyRepayment,
        amountInputForm: form.selectAmountWithSlider,
        earlyRepaymentSimulationSchedule:
            state?.api?.early_repayment_simulation,
        initialValues: {
            amount: integerToStringNumberWithIntlGroups(
                earlyRepayment.selectedInputAmount,
                intl.locale
            )
        }
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateSelectedAmount: (inputAmount: number, sliderAmount: number) =>
        dispatch({
            type: UPDATE_SELECTED_REPAYMENT_AMOUNT,
            inputAmount,
            sliderAmount
        }),
    requestSelectedAmount: () =>
        dispatch({ type: REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY }),
    goToConfirm: () => dispatch({ type: SHOW_CONFIRM_REPAYMENT_STEP }),
    showSchedule: (customSchedule: GetEarlyRepaymentSimulationResponse) => {
        dispatch({
            type: SHOW_REPAYMENT_SCHEDULE_MODAL,
            customSchedule
        });
    },
    changeForm: (value: number) => {
        dispatch(change('selectAmountWithSlider', 'amount', value));
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const ChooseRepaymentAmount = (props: PropsFromRedux) => {
    const { ready, goToConfirm } = props;

    if (ready) {
        return (
            <div className={styles.ChooseRepaymentAmount}>
                <IwMedia from="medium">
                    <TitleSectionWrapper>
                        <div className={styles.title}>
                            <FormattedMessage {...messages.title} />
                        </div>
                        {getCountry() === 'DE' && (
                            <div className={styles.subTitle}>
                                <FormattedMessage {...messages.subTitle} />
                            </div>
                        )}
                    </TitleSectionWrapper>
                </IwMedia>

                <MainSectionWrapper>
                    <PairItemContainer className={styles.repaymentSummary}>
                        <RepaymentSelectAmount {...props} />
                        <RepaymentAmountBreakdown {...props} />
                    </PairItemContainer>
                </MainSectionWrapper>
                <Prompt
                    stacked={true}
                    className={styles.prompt}
                    classNameActionButton="flex-col lg:flex-row"
                >
                    <DashboardLink isButton={true}>
                        <FormattedMessage {...messages.back} />
                    </DashboardLink>
                    <button onClick={goToConfirm}>
                        <FormattedMessage {...messages.next} />
                    </button>
                </Prompt>
            </div>
        );
    }

    return <MainContentPending />;
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChooseRepaymentAmount);
